import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Table } from "../../components";
import utils from "../../components/toastify/toastify";
import { fish_image } from "../../constant/urls";
import { useAppContext } from "../../context/state";
import { addCommas, useRequest } from "../../utils";
import moment from "jalali-moment";
//locall

const PaymentsProductToUser = (props) => {
  //   const data = props.location.query.data;
  //   const [
  //     verify_cart_fish_error,
  //     verify_cart_fish_loading,
  //     verify_cart_fish_data,
  //     verify_cart_fish_function,
  //   ] = useRequest({
  //     method: "post",
  //     url: "/verify_cart_fish",
  //     body: {
  //       payment_id: props.match.params.id,
  //     },
  //     isFunction: true,
  //   });
  let history = useHistory();

  const [
    get_payments_product_error,
    get_payments_product_loading,
    get_payments_product_data,
    get_payments_product_function,
  ] = useRequest({
    method: "post",
    url: "/get_payments_product",
    body: {
      user_id: props.match.params.user_id,
      product_id: props.match.params.product_id,
    },
  });

  console.log(get_payments_product_data);

  const data = get_payments_product_data?.data;

  return !data ? null : (
    <>
      <div class="content-header row">

      </div>
      <div class="content-body">
        <section className="card card-body">
          <div class="content-body">
            <h6>تراکنش های محصول :</h6>
            {data ? (
              <Table
                Thead={() => (
                  <tr>
                    <th className="table--title">شماره</th>
                    <th className="table--title">مبلغ</th>
                    <th className="table--title">نوع پرداخت</th>
                    <th className="table--title">توضیح پرداخت</th>
                    <th className="table--title">وضعیت</th>
                    <th className="table--title">تاریخ ایجاد تراکنش</th>

                    {/* <th className="table--title">نام محصول</th>
                <th className="table--title">متن نظر</th>
                <th className="table--title">امتیاز</th>
                <th className="table--title">عملیات</th> */}
                    <th className="table--title">عملیات</th>
                  </tr>
                )}
                Tbody={() =>
                  data.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{addCommas(item._price) + "تومان"}</td>
                      <td>
                        {item._type === "online" ? "آنلاین" : "کارت به کارت"}
                      </td>
                      <td>
                        {item._des === "initial_payment"
                          ? "پرداخت اولیه"
                          : null}
                        {item._des === "term_support_payment"
                          ? "پرداخت پشتیبانی ترم"
                          : null}
                        {item._des === "term_payment" ? "پرداخت ترم" : null}
                        {item._des === "manual_payment" ? "پرداخت دستی" : null}
                      </td>
                      <td>
                        {item._status === "paid"
                          ? "موفق"
                          : item._status === "waiting"
                          ? "در انتظار تایید"
                          : "ناموفق"}
                      </td>
                      <td style={{ direction: "ltr" }}>
                        {moment(item.creation_date)
                          .locale("fa")
                          .format("YYYY/MM/DD, h:mm:ss a")}
                      </td>
                      <td>
                        <Link
                          to={{
                            pathname: "/dashboard/paymentDetails/" + item._id,
                          }}
                        >
                          <button
                            type="button"
                            class="btn btn-primary round mr-1 mb-1 btn-sm"
                          >
                            جزییات
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))
                }
              />
            ) : null}
          </div>
        </section>
      </div>
      {/* <!-- BEGIN: Content--> */}
    </>
  );
};

export { PaymentsProductToUser };
